export default __webpack_public_path__ + "static/media/demo_assembly.2b37e8b1.webp";